import { render } from "./QuickAddModal.vue?vue&type=template&id=480dacbb&scoped=true"
import script from "./QuickAddModal.vue?vue&type=script&lang=js"
export * from "./QuickAddModal.vue?vue&type=script&lang=js"

import "./QuickAddModal.vue?vue&type=style&index=0&id=480dacbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480dacbb"]])

export default __exports__